export const OPEN_LEARNER_SETTINGS_EVENT = 'app:open-learner-settings';

export type LearnerSettingsFocusTarget = 'inAppAlerts';

export interface OpenLearnerSettingsDetail {
  tab?: 'region' | 'security' | 'notifications' | 'lessonText';
  focus?: LearnerSettingsFocusTarget;
}

export function openLearnerSettings(detail?: OpenLearnerSettingsDetail): void {
  window.dispatchEvent(
    new CustomEvent<OpenLearnerSettingsDetail>(OPEN_LEARNER_SETTINGS_EVENT, { detail: detail ?? {} })
  );
}

export function openLearnerSettingsToInAppAlerts(): void {
  openLearnerSettings({ tab: 'notifications', focus: 'inAppAlerts' });
}
